import React, { useEffect, useState } from "react";
import { ICVActivityFilterType } from "../../../models/ICVActivitiesModels";
import { DEFAULT_OPTION } from "../../../utils/Constant";
import { useDispatch, useSelector } from "react-redux";
import { FormUtils, SelectOptionType } from "../../../utils/FormUtils";
import { icvGetAllLevel5DataAPICall, icvGetAllSeasonsDataAPICall, icvGetAllVillagesDataAPICall, icvGetCropBySearchAPICall, icvGetDistrictsDataAPICall, icvGetMandalDataAPICall, icvGetStatesDataAPICall, icvGetSurveyStatusDataAPICall, icvGetYearDataAPICall, icvGetQCUsersAPICall } from "../../../api/icvActivityAPI";
import { Button, Col, Row } from "reactstrap";
import MultiSelectDropdown from "../../../components/MultiSelectDropdown";
import KDatePicker from "../../../components/KDatePicker";
import SelectBox from "../../../components/SelectBox";
import SearchBox from "../../../components/SearchBox";
import moment from "moment";
import "../icvActivities/ICVStyles.css";
import { clearSelectedICVActivities, handleICVGetDistrictDataSlice, handleICVGetLevel5DataSlice, handleICVGetMandalDataSlice, handleICVGetVillagesDataSlice } from "../../../redux/slices/icvActivitySlice";
import { filterICVStatus, filterOptionsByRole } from "../../../utils/Util";
import { LoggedUserType } from "../../../models/GlobalModels";
import { loginSelector } from "../../../redux/slices/loginSlice";
import { ROLE_IDS } from "../../../utils/RBAC";
import SendIcon from '@mui/icons-material/Send';
import RestartAltTwoToneIcon from '@mui/icons-material/RestartAltTwoTone';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import { toast } from "react-toastify";

interface ICVFilterProps {
    filter: ICVActivityFilterType;
    onApplyFilters: (ICVActivityFilter: ICVActivityFilterType, shouldCallAPI?: boolean) => void;
}

const ICVActivityFilters = ({ filter, onApplyFilters, }: ICVFilterProps) => {
    const user: LoggedUserType = useSelector(loginSelector).user;
    const [icvFilter, setIcvFilter] = useState<ICVActivityFilterType>({
        state: DEFAULT_OPTION,
        district: DEFAULT_OPTION,
        mandal: DEFAULT_OPTION,
        cropVillage: [],
        season: DEFAULT_OPTION,
        cropId: [],
        year: DEFAULT_OPTION,
        fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
        patwarName: DEFAULT_OPTION,
        toDate: undefined,
        surveyStatus: DEFAULT_OPTION,
        gramPanchayat: [],
        qcName: DEFAULT_OPTION,
        kmlId: '',
        surveyorMobileNumber: ''
    });
    const [selectedValues, setSelectedValues] = useState<string[]>([]);
    const [isResetEnabled, setIsResetEnabled] = useState(false);

    const {
        storeICVGetStatesData,
        storeICVGetSeasonsData,
        storeICVGetYearData,
        storeICVGetDistrictData,
        storeICVGetMandalData,
        storeICVGetVillagesData,
        storeICVGetLevel5Data,
        storeICVGetCropsMastersData,
        storeICVGetSurveyStatusData,
        storeICVGetQCUsersData,
    } = useSelector((state: any) => state.icvActivity);
    const dispatch: any = useDispatch();

    // Sync internal state with the filter prop
    useEffect(() => {
        if (user?.roleId === ROLE_IDS.QUALITY_CHECKER) {
            setIcvFilter({...filter, qcName: {label: user?.employeeName, value: user?.userId, email: user?.emailId }})
        }
        else{
            setIcvFilter(filter);
        }
    }, [filter]);

    const handleReset = () => {
        dispatch(handleICVGetDistrictDataSlice({}));
        dispatch(handleICVGetMandalDataSlice({}));
        dispatch(handleICVGetLevel5DataSlice({}));
        dispatch(handleICVGetVillagesDataSlice({}));
        setSelectedValues([]);
        const defaultResetFilter = {
            state: DEFAULT_OPTION,
            district: DEFAULT_OPTION,
            mandal: DEFAULT_OPTION,
            cropVillage: [],
            season: DEFAULT_OPTION,
            cropId: [],
            year: DEFAULT_OPTION,
            fromDate: moment(new Date)?.subtract('1', 'months')?.toDate(),
            patwarName: DEFAULT_OPTION,
            toDate: undefined,
            surveyStatus: DEFAULT_OPTION,
            gramPanchayat: [],
            qcName: DEFAULT_OPTION,
            kmlId: '',
            surveyorMobileNumber: ''
        };
        if (user?.roleId === ROLE_IDS.QUALITY_CHECKER) {
            defaultResetFilter.qcName = {label: user?.employeeName, value: user?.userId, email: user?.emailId };
        }
        setIcvFilter(defaultResetFilter);
        onApplyFilters(defaultResetFilter, false); // Pass false to prevent API call
        setIsResetEnabled(false);
        dispatch(clearSelectedICVActivities());
        toast.success('Filter criteria is cleared');
    };

    const onchangeDropdown = (label: string, event: SelectOptionType) => {
        switch (label) {
            case "state":
                dispatch(handleICVGetDistrictDataSlice({}));
                dispatch(handleICVGetMandalDataSlice({}));
                dispatch(handleICVGetVillagesDataSlice({}));
                dispatch(handleICVGetLevel5DataSlice({}));
                if (event && event?.value) {
                    const stateValue = (event?.value);
                    dispatch(icvGetDistrictsDataAPICall(stateValue));
                    dispatch(icvGetCropBySearchAPICall("", stateValue))
                }
                else {
                    dispatch(icvGetCropBySearchAPICall(""));
                }

                setIcvFilter((prev: any) => ({
                    ...prev,
                    state: event,
                    district: DEFAULT_OPTION, // Reset district dropdown
                    mandal: DEFAULT_OPTION, // Reset mandal dropdown
                    patwarName: DEFAULT_OPTION, // Reset patwar dropdown
                    cropVillage: [], // Reset crop village selection
                    gramPanchayat: [], // Reset gram panchayat selection
                }));
                break;

            case "district":
                dispatch(handleICVGetMandalDataSlice({}));
                dispatch(handleICVGetVillagesDataSlice({}));
                dispatch(handleICVGetLevel5DataSlice({}));
                if (typeof icvFilter?.state?.value === "string") {
                    if (event?.value) {
                        const districtValue = (event?.value);
                        dispatch(
                            icvGetMandalDataAPICall(
                                (icvFilter?.state?.value),
                                districtValue
                            )
                        );
                        dispatch(icvGetCropBySearchAPICall("", icvFilter?.state?.value, districtValue))
                    }
                    else {
                        dispatch(icvGetCropBySearchAPICall("", icvFilter?.state?.value));
                    }
                }
                else {
                    dispatch(icvGetCropBySearchAPICall(""));
                }

                setIcvFilter((prev: any) => ({
                    ...prev,
                    district: event,
                    mandal: DEFAULT_OPTION, // Reset mandal dropdown
                    patwarName: DEFAULT_OPTION, // Reset patwar dropdown
                    cropVillage: [], // Reset crop village selection
                    gramPanchayat: [], // Reset gram panchayat selection
                }));
                break;

            case "mandal":
                dispatch(handleICVGetVillagesDataSlice({}));
                dispatch(handleICVGetLevel5DataSlice({}));
                if (
                    typeof icvFilter?.state?.value === "string" &&
                    typeof icvFilter?.district?.value === "string" &&
                    event?.value
                ) {
                    const mandalValue = (event?.value); 
                    dispatch(
                        icvGetAllVillagesDataAPICall(
                            (icvFilter?.state?.value),
                            (icvFilter?.district?.value),
                            mandalValue
                        )
                    );
                    dispatch(
                        icvGetAllLevel5DataAPICall(
                            (icvFilter?.state?.value),
                            (icvFilter?.district?.value),
                            mandalValue
                        )
                    );
                }

                setIcvFilter((prev: any) => ({
                    ...prev,
                    mandal: event,
                    patwarName: DEFAULT_OPTION, // Reset patwar dropdown
                    cropVillage: [], // Reset crop village selection
                    gramPanchayat: [], // Reset gram panchayat selection
                }));
                break;

            case "cropVillage":
                setIcvFilter((prev: any) => ({
                    ...prev,
                    cropVillage: event?.label ? [event] : [], // Set the selected crop village
                }));
                break;
            case "season":
                // Here event will be the selected option object, so we directly set it
                setIcvFilter((prev: any) => ({
                    ...prev,
                    season: event, // Update the season to the selected object (e.g., { label: 'Winter', value: 'winter' })
                }));
                break;
            case "year":
                setIcvFilter((prev: any) => ({
                    ...prev,
                    year: event, // Store the whole selected option object
                }));
                break;
            case "surveyStatus":
                setIcvFilter((prev: any) => ({
                    ...prev,
                    surveyStatus: event, // Store the whole selected option object
                }));
                break;
            case "qcName":
                if (user?.roleId === ROLE_IDS.QUALITY_CHECKER) {
                    return;
                }
                setIcvFilter((prev: any) => ({
                    ...prev,
                    qcName: event, // Store the whole selected option object
                }));
                break;
            default:
                break;
        }
    };

    const statesData = FormUtils.convertDataList(
        storeICVGetStatesData?.data ?? []
    );

    const seasonsData = FormUtils.convertDataListValue(
        storeICVGetSeasonsData?.data ?? []
    );
    const yearData = FormUtils.convertToDataListObject(
        storeICVGetYearData?.data ?? []
    );
    const districtData = FormUtils.convertDataList(
        storeICVGetDistrictData?.data ?? []
    );
    const mandalData = FormUtils.convertDataList(
        storeICVGetMandalData?.data ?? []
    );
    const villagesData = FormUtils.convertVillagesDataList(
        storeICVGetVillagesData?.data ?? []
    );
    const level5Data = FormUtils.convertDataList(
        storeICVGetLevel5Data?.data ?? []
    );
    const cropMastersData = FormUtils.convertDataList(
        storeICVGetCropsMastersData?.data ?? []
    );
    const surveyStatusData = filterICVStatus(FormUtils.convertDataList(
        storeICVGetSurveyStatusData?.data ?? []
    ));
    const qcUsersData = storeICVGetQCUsersData?.data || [];

    // Filter options based on user role and accessed states/districts
    const filteredStatesData = filterOptionsByRole(
        statesData,
        user?.roleId || 0,
        user?.accessedStates || [],
        [],
        'states'
    );
    const filteredDistrictData = filterOptionsByRole(
        districtData,
        user?.roleId || 0,
        [],
        user?.accessedDistricts || [],
        'districts'
    );

    const handleCropVillageChange = (values: any) => {
        // Should log the selected values
        setIcvFilter((prev) => {
            return { ...prev, cropVillage: values };
        });
    };
    const handleCropGramPanchayatChange = (values: any) => {
        setIcvFilter((prev) => {
            return { ...prev, gramPanchayat: values };
        });
    };
    const handleCropNameChane = (values: any) => {
        // Should log the selected values
        setIcvFilter((prev) => {
            return { ...prev, cropId: values };
        });
    };

    const handleSearchMobileNumber = (e: any) => {
        let value = e.target.value;
        if (value.length > 10) {
            value = value.substring(0, 10);
        }
        value = value.replace(/[^0-9]/g, '').replace(/^([6-9][0-9]{0,9}).*$/, '$1');
        e.target.value = value;
        setIcvFilter({
            ...icvFilter,
            surveyorMobileNumber: e?.target?.value,
        });
    };

    useEffect(() => {
        // Fetch initial data on component mount
        dispatch(icvGetStatesDataAPICall());
        dispatch(icvGetAllSeasonsDataAPICall());
        dispatch(icvGetYearDataAPICall());
        dispatch(icvGetSurveyStatusDataAPICall());
        dispatch(icvGetCropBySearchAPICall("")); // Assuming this fetches crop data
        dispatch(icvGetQCUsersAPICall()); // Fetch QC users from Keycloak
    }, [dispatch]);

    return (
        <>
            <div className="filter-section">
                <Row>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="State"
                            options={filteredStatesData}
                            value={icvFilter.state}
                            className="css-select-bg"
                            onChange={(event) => onchangeDropdown("state", event)}
                        />
                    </Col>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="District"
                            options={filteredDistrictData}
                            value={icvFilter.district}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("district", value)}
                        />
                    </Col>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="Tehsil/Block"
                            options={mandalData}
                            value={icvFilter.mandal}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("mandal", value)}
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MultiSelectDropdown
                            options={level5Data}
                            label="Gram Panchayat Name"
                            value={selectedValues}
                            onChange={handleCropGramPanchayatChange}
                        />
                    </Col>
                    <Col xs={4} md={3}>
                        <MultiSelectDropdown
                            options={villagesData}
                            label="Crop village"
                            value={selectedValues}
                            onChange={handleCropVillageChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="Season"
                            options={seasonsData}
                            value={icvFilter.season}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("season", value)}
                        />
                    </Col>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="Year"
                            options={yearData}
                            value={icvFilter.year}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("year", value)}
                        />
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <KDatePicker
                            label="From Date"
                            value={icvFilter.fromDate}
                            minDate={moment().subtract(1, "years").toDate()}
                            maxDate={new Date()}
                            onChange={(date: any) => {
                                setIcvFilter({
                                    ...icvFilter,
                                    fromDate: date,
                                    toDate: undefined,
                                });
                            }}
                            labelIcon={<InfoTwoToneIcon className="label-icon-date-picker"/>}
                            labelIconTooltipContent={'Survey Completion From Date'}
                        />
                    </Col>
                    <Col xs={12} md={2} lg={2}>
                        <KDatePicker
                            disabled={icvFilter.fromDate === undefined}
                            label="To Date"
                            minDate={icvFilter.fromDate}
                            maxDate={new Date()}
                            value={icvFilter.toDate}
                            onChange={(date: any) => {
                                setIcvFilter({
                                    ...icvFilter,
                                    toDate: date,
                                });
                            }}
                            labelIcon={<InfoTwoToneIcon className="label-icon-date-picker"/>}
                            labelIconTooltipContent={'Survey Completion To Date'}
                        />
                    </Col>
                    <Col xs={6} md={4}>
                        <MultiSelectDropdown
                            options={cropMastersData}
                            label="Crop Name"
                            value={selectedValues}
                            onChange={handleCropNameChane}
                        />
                    </Col>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="Survey Status"
                            options={surveyStatusData}
                            value={icvFilter.surveyStatus}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("surveyStatus", value)}
                        />
                    </Col>
                    <Col xs={6} md={2}>
                        <SelectBox
                            label="QC Executive"
                            options={qcUsersData}
                            value={icvFilter.qcName}
                            className="css-select-bg"
                            onChange={(value) => onchangeDropdown("qcName", value)}
                            disabled={user?.roleId === ROLE_IDS.QUALITY_CHECKER}
                        />
                    </Col>
                    <Col xs={6} md={3}>
                        <div style={{ position: "relative" }}>
                            <SearchBox
                                label="Surveyor Number"
                                placeHolder="Search with Surveyor Mobile No."
                                value={icvFilter.surveyorMobileNumber}
                                onChange={handleSearchMobileNumber}
                                numberOnly={true}
                                maxLength={10}
                            />
                        </div>
                    </Col>
                    <Col xs={6} md={2}>
                        <div style={{ position: "relative" }}>
                            <SearchBox
                                label="KML ID"
                                placeHolder="Search with KML ID"
                                value={icvFilter.kmlId}
                                onChange={(e: any) => {
                                    setIcvFilter({
                                        ...icvFilter,
                                        kmlId: e?.target?.value,
                                    });
                                }}
                            />
                        </div>
                    </Col>
                    <Col xs={6} md={3} className="d-flex justify-content-end align-items-center pt-1 mt-3">
                        <Button
                            variant="contained"
                            className="mx-2 cl-btn-outline-primary w-auto d-flex align-items-center justify-content-between"
                            onClick={handleReset}
                        >
                            Reset
                            <RestartAltTwoToneIcon/>
                        </Button>
                        <Button
                            variant="contained"
                            className="ms-2 cl-btn-primary d-flex align-items-center"
                            onClick={() => {
                                onApplyFilters(icvFilter, true); // Pass true to ensure API call
                                setIsResetEnabled(true);
                            }}
                        >
                            Submit
                            <SendIcon sx={{ fontSize: '18px', marginLeft: '5px' }} />
                        </Button>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default ICVActivityFilters;
